import {
  FluidIconConfig,
  FluidPopoverConfig,
  isNullOrUndefined,
} from '@lmig/fluid-core';

import { validatePopoverProp } from '../logging/deprecation.utils';

/**
 * mapConfigObjectToProp
 * @param props
 * @param mapFrom
 * @param mapTo
 */
export function mapConfigObjectToProp<T>(
  props: any,
  mapFrom: string,
  mapTo: string
): T {
  if (typeof props[mapFrom] === 'object') {
    props[mapTo] = props[mapFrom];
  }
  return props as T;
}

/**
 * Finds all embedded Popover config properties (including deprecated
 * Props) within a given FluidIconConfig & compiles them into a single
 * FluidPopoverConfig object, then DELETES the properties from the
 * original FluidIconConfig. This effectively extracts the Icon's
 * embedded Popover so that it can be used separately from the Icon.
 * @param iconConfig - FluidIconConfig containing the FluidPopoverConfig to be extracted
 * @param host - host HTMLElement for deprecation warning
 */
export const extractIconPopoverConfig = (
  iconConfig: FluidIconConfig,
  host: HTMLElement
): FluidPopoverConfig => {
  if (!iconConfig) return;

  const persistable = iconConfig.popoverPersistable;
  delete iconConfig['popoverPersistable'];

  const placement = iconConfig.popoverPlacement;
  delete iconConfig['popoverPlacement'];

  const width = iconConfig.popoverWidth;
  delete iconConfig['popoverWidth'];

  const config: FluidPopoverConfig = validatePopoverProp(
    host,
    iconConfig.popoverConfig,
    iconConfig.popover
  );
  delete iconConfig['popoverConfig'];
  delete iconConfig['popover'];

  return {
    ...(!isNullOrUndefined(persistable) && { persistable }),
    ...(!isNullOrUndefined(placement) && { placement }),
    ...(!isNullOrUndefined(width) && { width }),
    ...config,
  };
};
